<template>
  <div class="screen-task-page" v-loading="loading">
    <div class="con-body">
      <div class="control-group">
        <div class="group-left">
          <el-button
            type="primary"
            size="small"
            @click="openEditWin('create')"
            class="insert-btn"
            ><svg-icon name="add-plus"></svg-icon>{{$t('control.add')}}</el-button
          >
        </div>
      </div>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="id" label="ID" width="100"> </el-table-column>
        <el-table-column prop="name" :label="$t('screen.task_name')"> </el-table-column>
        <el-table-column :label="$t('screen.implement_programs')">
          <template slot-scope="scope">
            <span>{{scope.row.program_name}}({{scope.row.program_id}})</span>
          </template>
        </el-table-column>
        <el-table-column prop="start_time" :label="$t('control.start_time')"> </el-table-column>
        <el-table-column prop="end_time" :label="$t('control.over_time')"> </el-table-column>
        <el-table-column prop="created_at" :label="$t('screen.task_addition_time')"> </el-table-column>
        <el-table-column lprop="status" :label="$t('screen.task_state')" >
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.status"
              :active-value="1"
              :inactive-value="0"
              active-color="#67C23A"
              inactive-color="#aaaaaa"
              @change="changeSetTask(scope.row.id,scope.row.status)"
            />
          </template>
        </el-table-column>
        <el-table-column prop="edit" :label="$t('control.operate')" width="100">
          <template slot-scope="scope">
            <div class="edit-button">
              <i
                @click="openEditWin(scope.row)"
                class="el-icon-edit pointer mar-r10"
              ></i>
              <i
                class="el-icon-delete pointer"
                @click="delItem(scope.row.id)"
              ></i>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageInfo.page"
        :page-sizes="[10, 20, 30, 40, 50, 100]"
        :page-size="pageInfo.pageSize"
        layout="sizes, total, prev, pager, next, jumper"
        :total="cnt_all"
      >
      </el-pagination>
    </div>
    <!--新增对话框-->
    <el-dialog
      class="dialog750"
      :title="editType === 'create' ? $t('control.add') : $t('control.edit')"
      :visible.sync="dialogVisible"
      v-if="dialogVisible"
    >
      <el-form
        :model="editOne"
        label-position="left"
        :rules="editOneRule"
        label-width="160px"
      >
        <div class="form-info">
          <el-form-item :label="$t('screen.task_name')" prop="name">
            <el-input v-model="editOne.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('screen.start_and_end_date')" prop="date">
            <el-date-picker
              v-model="editOne.date"
              size="medium"
              type="daterange"
              :range-separator="$t('control.to')"
              :start-placeholder="$t('control.start_date')"
              :end-placeholder="$t('control.over_date')"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              @change="clearChange"
              >
            </el-date-picker>
          </el-form-item>
   
          <el-form-item :label="$t('screen.implement_programs')" prop="programId">
            <el-select
              clearable
              filterable 
              :placeholder="$t('screen.select_implement_programs')"
              v-model="editOne.program_id"
              style="width: 100%"
            >
              <el-option
                v-for="t in programList"
                :key="t.id"
                :label="t.program_name"
                :value="t.id"
              ></el-option>
            </el-select>
          </el-form-item>

        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button 
          class="mw-edit-button" 
          @click="dialogVisible = false"
          size="medium"
          >{{$t('control.cancel')}}</el-button
        >
        <el-button
          type="primary"
          @click="createItem"
          size="medium"
          v-if="editType === 'create'"
          >{{$t('control.confirm')}}</el-button
        >
        <el-button
          type="primary"
          @click="updateItem"
          size="medium"
          v-if="editType === 'update'"
          >{{$t('control.confirm')}}</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import taskApi from "@/api/message/taskList"
import programApi from "@/api/message/programList"
export default {
  data() {
    return {
      loading: false,
      dialogVisible: false,
      programList: [],
      tableData: [],
      pageInfo: {
        page: 1,
        pageSize: 10,
      },
      cnt_all: 0,
      editOneRule: {
        name: [{ required: true, message: this.$t('device.please_name'), trigger: "blur" }],
        date: [{ required: true, message: this.$t('screen.start_and_end_date'), trigger: "blur" }],
        programId: [{ required: true, message: this.$t('screen.select_implement_programs'), trigger: "blur" }],
      },
      editType: -1,
      devSelect: [],
      editOne: {
        id: 0,
        name: '',
        date: [],
        program_id: '',
        start_time: '',
        end_time: ''
      },
    };
  },
  methods: {
    getTableData(pageIndex) {
      // 获取列表
      this.pageInfo.page = pageIndex
      this.loading = true
      taskApi.programTaskList(this.pageInfo).then((res) => {
        if (res.data.code === 1000) {
          this.loading = false;
          let resData = res.data.data;
          this.tableData = resData.list;
          this.pageInfo.page = pageIndex;
          this.cnt_all = parseInt(resData.count);
          this.getProgramList()
        }
      })
    },

    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getTableData(this.pageInfo.page);
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val;
      this.getTableData(this.pageInfo.page);
    },

    openEditWin(index) {
      if (index === "create") {
        this.editOne = {
          name: '',
          date: [],
          program_id: '',
          start_time: '',
          end_time: ''
        };
        this.editType = "create";
      } else {
        // console.log('index',index)
        this.editOne = {
          id: index.id,
          name: index.name,
          program_id: parseInt(index.program_id),
          start_time: index.start_time,
          end_time: index.end_time,
        };
        this.editOne.date=[index.start_time,index.end_time]
        this.editType = "update";
      }
      this.dialogVisible = true;
    },

    updateItem() {
      this.editOne.start_time = this.editOne.date[0]
      this.editOne.end_time = this.editOne.date[1]
      taskApi.programTaskEdit(this.editOne.id, this.editOne).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success(this.$t('control.mod_success'));
          this.dialogVisible = false;
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },

    createItem() {
      this.editOne.start_time = this.editOne.date[0]
      this.editOne.end_time = this.editOne.date[1]

      taskApi.programTaskAdd(this.editOne).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success(this.$t('control.add_success'));
          this.dialogVisible = false;
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      })
    },
    
    delItem(id) {
      this.$confirm(this.$t('control.tip_del_data_title'), this.$t('control.tip'), {
        confirmButtonText: this.$t('control.confirm'),
        cancelButtonText: this.$t('control.cancel'),
        type: "warning",
      })
        .then(() => {
          taskApi.programTaskDel(id).then((res) => {
            if (res.data.code === 1000) {
              this.$message.success(this.$t('control.del_success'));
              this.getTableData(this.pageInfo.page);
            } else {
              this.$message.error(res.data.message);
            }
          })
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t('control.cancel_del'),
          });
        });
    },
    changeSetTask(id, value) {
      let status=0
      if(value){
        status=1
      }
      taskApi.programTaskSet({ id: id, status: status }).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success(res.data.message);
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    getProgramList() { 
      programApi.programList({
        page: 1,
        pageSize: 1000
      }).then((res) => {
        if (res.data.code === 1000) {
          let resData = res.data.data;
          this.programList = resData.list;
        }
      })
    },
    clearChange(value) {
      if (!value) {
        this.$nextTick(() => {
          this.editOne.date = ''
        })
      }
    }
  },
  mounted() {
    this.getTableData(this.pageInfo.page);
  }
};
</script>
<style lang='less'>
.screen-task-page {
  width: 100%;
  .el-form-item__error{
    padding-top: 4px;
  }
  .form-info{
    padding-left: 12px;
    .el-form-item__label{
      width:120px;
    }
  }
  
}
</style>
